<script>
  import {mapGetters} from 'vuex';
  import {Line} from "vue-chartjs";
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
  import ChartMixin from '@/mixins/charts';

  export default {
    extends: Line,
    props: ['chartdata', 'options', 'width', 'height', 'datalabels'],
    mixins: [ChartMixin],
    computed: {
      ...mapGetters({
        chartColors: 'helper/getChartColors'
      }),
    },
    mounted() {
      this.customRenderChart(true)
    },
    methods: {
      customRenderChart: function(enableAnimations) {
        this.chartdata.datasets.forEach((dataset, i) => {
          dataset.borderColor = this.chartColors[i % this.chartColors.length ];
          dataset.fill = false;
        });

        this.options.tooltips = {};
        this.options.tooltips.callbacks = {
          label: function(t, d) {
            let xLabel = d.datasets[t.datasetIndex].label;
            let field = d.datasets[t.datasetIndex].field;

            if(field.includes('currency')) {
              return xLabel + ': $ ' + t.yLabel.toFixed(2);
            }

            return xLabel + ': ' + t.yLabel;
          }
        }

        this.options.animation = enableAnimations;

        this.options.plugins = {
          datalabels: {
            color: this.datalabels ? '#000000' : 'transparent',
            align: 'right',
            anchor: 'end',
          }
        }

        this.addPlugin(ChartJsPluginDataLabels);

        // this sets white background when printing chart
        this.addBackgroundPlugin(this);

        this.renderChart(this.chartdata, this.options)
      }
    },
    watch: {
      datalabels: function(d) {
        this.customRenderChart();
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// LineChart.vue?5e2e0d57